import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const PROJECT_URL = 'https://tgbzgwlmibepshrojdjo.supabase.co';
const DEFAULT_PUBLISHABLE_KEY = 'sb_publishable_2qyOw9K4JDalQix8sFZXDA_rK8BWkJ5';

let client: SupabaseClient | null = null;

// Compatibility helpers retained only so older Settings code still compiles.
// Runtime connection always uses DEFAULT_PUBLISHABLE_KEY.
export function getStoredPublicKey(): string {
  return DEFAULT_PUBLISHABLE_KEY;
}

export function savePublicKey(_key: string): void {
  localStorage.removeItem('ecc2_public_key');
  client = null;
}

export function clearPublicKey(): void {
  localStorage.removeItem('ecc2_public_key');
  client = null;
}

export function getSupabase(): SupabaseClient {
  if (!client) {
    client = createClient(PROJECT_URL, DEFAULT_PUBLISHABLE_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
  }
  return client;
}

export const supabaseProjectUrl = PROJECT_URL;
